var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.446 11.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3850"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3283",
    d: "M11.689.887H9.017v-.13A.758.758 0 008.26 0H4.388a.758.758 0 00-.757.757v.13H.758a.758.758 0 00-.757.757v9.493a.758.758 0 00.757.757H11.69a.758.758 0 00.757-.757V1.644a.758.758 0 00-.758-.757zm-7.49-.13a.188.188 0 01.188-.188h3.872a.188.188 0 01.188.188v.861a.188.188 0 01-.188.188H4.387a.188.188 0 01-.188-.188zm7.678 10.38a.188.188 0 01-.188.188H.757a.188.188 0 01-.188-.188V1.644a.188.188 0 01.188-.188H3.63v.163a.758.758 0 00.757.757h3.872a.758.758 0 00.757-.757v-.163h2.672a.188.188 0 01.188.188z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3853"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3852"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3851"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3284",
    d: "M9.886 3.914l-.47 1.753-.44-.441-1.9 1.9-1.3-1.3L3.2 8.402v-.8l2.576-2.577 1.3 1.3 1.5-1.5-.44-.441z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3854"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2027",
    d: "M3.212 8.882h.686v1.49h-.686z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3855"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2028",
    d: "M4.583 8.236h.686v2.135h-.686z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3856"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2029",
    d: "M5.955 7.69h.686v2.682h-.686z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3857"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2030",
    d: "M7.327 8.062h.686v2.309h-.686z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3858"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2031",
    d: "M8.699 7.193h.686v3.178h-.686z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3859"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2032",
    d: "M3.204 4.073v-.686h3.178v.686z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateReport);
export default __webpack_public_path__ + "static/media/CreateReport.f7807f4e.svg";
export { ForwardRef as ReactComponent };